import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 512,
			height: 512,
			fill: "#452075"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .82,
			d: "M163.84 407.047L256 325.454V92.1669L163.84 173.76V407.047Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 92.16,
			height: 92.16,
			transform: "matrix(1 0 0 -1 256 417.281)",
			fill: "white"
		})
	]
});
export default SvgLogoIcon;
